module Meevo.Plugins.Egifts {
    'use strict';

    import SortDirection = Meevo.Model.SortDirection;
    import CoSearchType = Meevo.Model.CoSearchType;


    interface ICriteria {
        services: Array<EgiftServicesSection.ISelectedService>;
    }


    export class ServicesSection extends EgiftsBaseSection {

        public arrayResults: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        public changedItems: any = {
            services: []
        };
        public serviceCategory = null;
        public businessType = null;
        
        public locationFilters: Array<EgiftServicesSection.ILocationFilters> = this.getlocationFilters()
        public filterByLocation = this.locationFilters[0];


        public request: EgiftServicesSection.IServicesRequest = this.defaulRequestModel;
        public showCOcolumn = this.canShowCO;

        reloadData() {
            if (this.changedItems.services.length > 0) {
                this.changedItems.services = [];
                this.getData(true);
            }
        }

        getData(isNotResetSearchOption?: boolean): void {
            if (!isNotResetSearchOption) {
                this.request.criteria.isAvailableAsEgift = this.serviceCategory = this.businessType = null;
                this.request = this.defaulRequestModel;
            }            
            
            let request: EgiftServicesSection.IServicesRequest = this.getRequest(),
                url: string = 'eGift/Service';

            if (!request.criteria.isAvailableAsEgift) {
                request.criteria.isAvailableAsEgift = null;
            }

            //this.busyService.start();
            this.arrayResults = this.getResults(url, this.onGetData.bind(this), true);
            this.arrayResults.initSearch(request);
        }

        onGetData(pageNumber, items) {
            this.busyService.stop();
        }

        saveData(): angular.IPromise<any> {
            this.context.loadingInProgress = true;
            return this.egiftsService.updateServices(this.changedItems)
                .then((data: any) => {
                    this.model = data;
                    this.activate();
                    this.context.setMode(Meevo.Model.MaintenanceFormState.Readonly);
                    this.loggingService.trace(`Updates saved.`);
                    this.reloadData();
                })
                .finally(() => {
                    this.context.loadingInProgress = false;
                    this.context.postUpdate(this.model);
                });
        }

        hideSortArrow(sortBy: string, sortDirection: number): boolean {
            return this.request.sortBy === sortBy && this.request.sortDirection === sortDirection;
        }

        sort(sortBy: string, sortDirection: number): void {
            // Sort direction will be reseted to ascending, when click on other header
            // Otherwise, sort direction wil be changed to the opposite
            this.request.sortDirection = this.request.sortBy === sortBy ? +!this.request.sortDirection : SortDirection.Ascending;
            this.request.sortBy = sortBy;

            this.filter();
        }

        filter(): void {
            let request: EgiftServicesSection.IServicesRequest = this.getRequest();
            this.arrayResults.initSearch(request);

            this.showCOcolumn = this.canShowCO;
        }

        saveIsEgift(serviceListItem): void {
            let existedServiceItem = _.find(this.changedItems.services, (item: any) => {
                if (item.serviceId === serviceListItem.serviceId) {
                    item.isAvailableAsEgift = serviceListItem.isAvailableAsEgift;
                    return item;
                }
            });

            if (!existedServiceItem && serviceListItem.serviceId) {
                this.changedItems.services.push({
                    entityVersion: serviceListItem.entityVersion,
                    isAvailableAsEgift: serviceListItem.isAvailableAsEgift,
                    serviceId: serviceListItem.serviceId,
                    homeLocationId: serviceListItem.homeLocationId
                });
            }
        }

        private getRequest(): EgiftServicesSection.IServicesRequest {
            let request: EgiftServicesSection.IServicesRequest = angular.copy(this.request);
            if (this.businessType) {
                request.criteria.businessTypeId = this.businessType.id;
            }

            if (this.serviceCategory) {
                request.criteria.serviceCategoryId = this.serviceCategory.id;
            }
            if (this.context.isCommonLocation) {
                request.criteria.coOwned = this.filterByLocation.value;
            }

            return request;
        }

        clearFilters(): void {
            this.filterByLocation = this.locationFilters[0];
            this.getData(false);

            this.showCOcolumn = this.canShowCO;
        }

        get sortDirection() {
            return SortDirection;
        }



        get locationLevelCriteria() {
            return {
                coSearchType: 1,
                coOwned: this.filterByLocation.value
            }
        }

        get canShowCO(): boolean {
            return this.context.isCommonLocation && this.filterByLocation.value !== COBusinessType.Location;
        }

        //// Service DATA ////

        get defaulRequestModel(): EgiftServicesSection.IServicesRequest {
            let mainSection = _.first(this.context.sections);
            const asLocationId = mainSection && mainSection.model && !(mainSection.model.settings.requireClientToSelectLocation && mainSection.model.settings.selectedLocationWillReceiveFundsFromEgiftSales) ?
                mainSection.model.settings.locationId : undefined;

            return {
                criteria: {
                    isAvailableAsEgift: null,
                    objectState: Model.ObjectStateEnum.Active,
                    businessTypeId: null,
                    serviceCategoryId: null,
                    priceGroupId: null,
                    maintenanceMode: null,
                    isGlobal: null,
                    ...(this.context.isCommonLocation ? this.locationLevelCriteria : {})
                },
                itemsPerPage: 25,
                sortBy: 'shortcut',
                sortDirection: SortDirection.Ascending,
                asLocationId: asLocationId
            };
        } 

        getlocationFilters(): Array<EgiftServicesSection.ILocationFilters> {
            return [
                { value: COBusinessType.All, label: 'LABEL_ALL_SERVICES' },
                { value: COBusinessType.CentralOffice, label: 'LABEL_CO_SERVICES' },
                { value: COBusinessType.Location, label: 'LABEL_LOCATION_SERVICES' },
            ];
        }
    }
}